import Icon from "@material-ui/icons/CheckBox";
import IconOff from "@material-ui/icons/HighlightOff";
import {Typography, withStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import {DemandValidationTr} from "constants/DemandValidation";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import Button from "components/Button";
import GridBlock from "components/GridBlock";
import React from "react";

const style = theme => ({
    root: {},
    icon: theme.components.icon,
    center: {
        textAlign: "center"
    },
    info: {
        marginBottom: theme.spacing(2)
    }
})

function NoActiveApproval(
    {
        approvalObjectName,
        approvalSection,
        uncompletedApprovalObjectSections,
        startApproval,
        working,
        classes
    }) {

    return (
        <GridBlock
            direction='column'
            alignItems='center'
        >
            {
                uncompletedApprovalObjectSections.length === 0 ?
                    <Icon className={classes.icon} color='primary'/>
                    :
                    <IconOff className={classes.icon} color='primary'/>
            }
            <Typography variant='body1' className={classes.info}>
                {
                    uncompletedApprovalObjectSections.length === 0 ?
                        (approvalSection.status === DemandValidationSectionStatus.ERROR ? Tr(`${approvalObjectName}_preparing_approval_ready`) : Tr(`${approvalObjectName}_preparing_approval_finished`)) :
                        (<>
                            {Tr(`${approvalObjectName}_preparing_approval_error`)}
                            {
                                uncompletedApprovalObjectSections.map((x, i) =>
                                    `"${DemandValidationTr[x]}"${
                                        i === uncompletedApprovalObjectSections.length - 1 ? '.' : ', '
                                    }`
                                )}
                        </>)
                }
            </Typography>
            {uncompletedApprovalObjectSections.length === 0 && approvalSection.status === DemandValidationSectionStatus.ERROR &&
            <Typography variant='body1'>
                <Button
                    disabled={!approvalSection.editable || working}
                    onClick={() => startApproval()}
                >
                    {Tr('startApproval')}
                </Button>
            </Typography>
            }
        </GridBlock>
    );
}

NoActiveApproval.propTypes = {
    approvalObjectName: PropTypes.string,
    startApproval: PropTypes.func
}

export default withStyles(style)(NoActiveApproval);